import { render, staticRenderFns } from "./AddRoleP3.vue?vue&type=template&id=081dcf2d&scoped=true&"
import script from "./AddRoleP3.vue?vue&type=script&lang=js&"
export * from "./AddRoleP3.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleP3.vue?vue&type=style&index=0&id=081dcf2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081dcf2d",
  null
  
)

export default component.exports